/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Streaming Http content header definition.
 */
export interface IHttpContentHeaders {
    type?: string;
    contentLength?: number;
}
